import { Component, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';

@Component({
  selector: 'app-testosterone-therapy',
  imports: [UpsellCardComponent],
  styleUrls: ['./testosterone-therapy.component.scss'],
  templateUrl: './testosterone-therapy.component.html',
})
export class TestosteroneTherapyComponent {
  @Input() public htmlTitle: string = '<strong>Take Your Results Further with Testosterone Therapy</strong>';
  @Input() public question: string =
    'Would you like to add Testosterone Replacement Therapy for the most complete results?';
  public options: SelectableOption[] = [
    new SelectableOption(
      'Add Injectable TRT (+$119/mo) - Direct testosterone optimization to amplify peptide-driven recovery and performance',
      UpsellSlugs.InjectableTrt,
    ),
    new SelectableOption(
      'Add TRT + Enclomiphene (+$199/mo) - Balanced testosterone support designed to work alongside peptides',
      UpsellSlugs.TrtAndEnclomiphene,
    ),
    new SelectableOption(
      'Add TRT + hCG (+$199/mo) - Advanced hormonal support to sustain and enhance peptide results',
      UpsellSlugs.TrtAndHcg,
    ),
    new SelectableOption(
      "No, I don't want to try Testosterone Replacement Therapy at this time.",
      QuestionnaireAnswers.No,
    ),
  ];
  public readonly hints = ['Most patients try a form of TRT in combination with Peptide Therapy'];
}
